const OfficeTypes = [
  { key: "warehouse", "text": "Warehouse" },
  { key: "office", text: "Office" },
  { key: "containerYard", text: "Container Yard" }
];

export default OfficeTypes;